// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".formBody > * {\r\n    margin-bottom: 40px!important;\r\n}\r\n\r\n.formBody {\r\n    margin: auto;\r\n    width: 75%;\r\n    max-width: 1300px;\r\n    text-align: left;\r\n}\r\n\r\n@media only screen and (max-width: 600px) {\r\n    .formBody {\r\n        margin: 0 20px;\r\n        width: initial;\r\n    }\r\n\r\n    .formBody > * {\r\n        margin-bottom: 20px!important;\r\n    }\r\n\r\n}", ""]);
// Exports
module.exports = exports;
